/**
 * What this device calls its passkey, for the offer after an account is created (§14.89): the
 * owner should read a name they know ("Face ID"), not "passkey". The system sheet that follows
 * names the real method either way, so a near miss (an iPhone SE's Touch ID) costs nothing.
 */
export function passkeyNoun(ua: string): string {
  if (/iPhone|iPad/.test(ua)) return 'Face ID or Touch ID';
  if (/Macintosh|Mac OS X/.test(ua)) return 'Touch ID';
  if (/Android/.test(ua)) return 'your fingerprint or face';
  if (/Windows/.test(ua)) return 'Windows Hello';
  return 'a passkey';
}
